// src/store/modules/auth.js
import authService from '@/services/authService'; // API servisi
import userService from '@/services/userService';
import router from '@/router'; // Yönlendirme için router

// Helper to set token in Axios headers and localStorage
const setAuthData = (commit, token, user) => {
    localStorage.setItem('token', token);
    localStorage.setItem('user', JSON.stringify(user));
    // Axios header'ını da ayarlayabiliriz (api.js'deki interceptor bunu zaten yapmalı)
    // axios.defaults.headers.common['Authorization'] = token;
    commit('SET_TOKEN', token);
    commit('SET_USER', user);
};

const clearAuthData = (commit) => {
    localStorage.removeItem('token');
    localStorage.removeItem('user');
    // delete axios.defaults.headers.common['Authorization'];
    commit('CLEAR_AUTH');
};

export default {
  namespaced: true, // Modül isim alanı kullan
  state: {
    token: localStorage.getItem('token') || null,
    user: JSON.parse(localStorage.getItem('user')) || null,
  },
  mutations: {
    SET_TOKEN(state, token) {
      state.token = token;
    },
    SET_USER(state, user) {
      state.user = user;
    },
    CLEAR_AUTH(state) {
      state.token = null;
      state.user = null;
    },
    // Profil güncelleme için (opsiyonel)
    UPDATE_USER_PROFILE(state, updatedData) {
        if (state.user) {
            state.user = { ...state.user, ...updatedData };
            localStorage.setItem('user', JSON.stringify(state.user));
        }
    }
  },
  actions: {
    async login({ commit }, credentials) {
      commit('SET_LOADING', true, { root: true });
      commit('CLEAR_ERROR', null, { root: true });
      try {
        const response = await authService.login(credentials);
        const { token, user } = response.data;
        setAuthData(commit, token, user);
        // Giriş yaptıktan sonra yönlendir (eğer redirect query varsa oraya)
        const redirectPath = router.currentRoute.value.query.redirect || '/';
        router.push(redirectPath);
        return response;
      } catch (error) {
        const errorMessage = error.response?.data?.message || 'Giriş sırasında bir hata oluştu.';
        commit('SET_ERROR', errorMessage, { root: true });
        clearAuthData(commit); // Hata durumunda token vs temizle
        throw error; // Hatanın component'te de yakalanmasını sağla
      } finally {
        commit('SET_LOADING', false, { root: true });
      }
    },
    async register({ commit }, userData) {
       commit('SET_LOADING', true, { root: true });
       commit('CLEAR_ERROR', null, { root: true });
       try {
         const response = await authService.register(userData);
         // İsteğe bağlı: Kayıttan sonra otomatik giriş yaptırılabilir veya Login'e yönlendirilebilir
         router.push({ name: 'Login', query: { registered: 'true' } }); // Login sayfasına mesajla yönlendir
         return response;
       } catch (error) {
         const errorMessage = error.response?.data?.message || 'Kayıt sırasında bir hata oluştu.';
         commit('SET_ERROR', errorMessage, { root: true });
         throw error;
       } finally {
         commit('SET_LOADING', false, { root: true });
       }
    },
    logout({ commit }) {
      clearAuthData(commit);
      router.push({ name: 'Login' }); // Logout sonrası Login'e yönlendir
    },
    // Sayfa yenilendiğinde veya uygulama açıldığında token varsa kullanıcıyı doğrula
    async tryAutoLogin({ commit, state }) {
        const token = state.token;
        if (!token) {
            return false; // Token yoksa işlem yapma
        }
        // Token'ın süresinin dolup dolmadığı JWT kütüphanesi ile kontrol edilebilir (frontend'de)
        // Veya en sağlıklısı backend'e /me isteği atmak:
        try {
            const response = await authService.getMe(); // /api/auth/me'ye istek atar
            // Backend'den güncel kullanıcı bilgisi geldi, user state'ini güncelle (token zaten var)
            const user = response.data;
             localStorage.setItem('user', JSON.stringify(user)); // localStorage'ı da güncelle
            commit('SET_USER', user);
            return true;
        } catch (error) {
            // Token geçersiz veya backend hatası
            console.error("Auto-login failed:", error);
            clearAuthData(commit); // Geçersiz token'ı temizle
            return false;
        }
    },
    // Google'dan gelen token'ı işleme
    handleAuthCallback({ commit }, token) {
        // Token'ı aldıktan sonra backend'den kullanıcı bilgisini çekmek en sağlıklısı
        // Veya token'ı direkt kaydedip /me ile doğrulayabiliriz.
         localStorage.setItem('token', token); // Token'ı kaydet
         commit('SET_TOKEN', token);
         // /me isteği ile kullanıcıyı çek ve state'i güncelle (tryAutoLogin gibi)
         return this.dispatch('auth/tryAutoLogin'); // Zincirleme action çağrısı
    },
     // Profil güncelleme action'ı
     async updateProfile({ commit }, updatedData) {
        commit('SET_LOADING', true, { root: true });
        commit('CLEAR_ERROR', null, { root: true });
         try {
             const response = await userService.updateProfile(updatedData); // userService.js gerekli
             commit('UPDATE_USER_PROFILE', response.data); // Mutation'ı çağır
             return response.data;
         } catch (error) {
             const errorMessage = error.response?.data?.message || 'Profil güncelleme hatası.';
             commit('SET_ERROR', errorMessage, { root: true });
             throw error;
         } finally {
             commit('SET_LOADING', false, { root: true });
         }
     }

  },
  getters: {
    isAuthenticated: state => !!state.token, // Token varsa true döner
    currentUser: state => state.user,
    userRole: state => state.user?.role,
    userId: state => state.user?.id,
  }
}